<template>
  <div
    :class="color"
    :style="{
      padding: padding === undefined ? '5px 7px' : padding,
      display: 'inline-block',
      borderRadius: '0.5rem',
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    padding: String,
    color: {
      type: String,
      default: 'primary',
    },
  },
}
</script>
